import React from 'react';
import {Map, List} from 'immutable';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadSharingStore from 'stores/sharing/FileUploadSharingStore';
import FileUploadSharingDialogFormStore from 'stores/sharing/FileUploadSharingDialogFormStore';
import FileUploadSharingDialogForm from 'components/pure/sharing/direct-share/dialog/FileUploadSharingDialogForm';
import DepartmentStore from 'stores/department/DepartmentStore';
import UserStore from 'stores/UserStore';
import CallCardStore from '@store/call-card/CallCardStore';
import AuthStore from 'stores/AuthStore';

/**
 * <FileUploadSharingDialogFormContainer /> links `FileUploadSharingDialogFormStore`
 * to <FileUploadSharingDialogForm /> so that the latter can use `FileUploadSharingDialogFormActions`
 * to change the former
 */
class FileUploadSharingDialogFormContainer extends React.Component {
  static getStores() {
    return [
      DepartmentStore,
      FileUploadSharingDialogFormStore,
      FileUploadSharingStore,
      UserStore,
      AuthStore,
      CallCardStore,
    ];
  }

  static getPropsFromStores(props) {
    const sessionUser = AuthStore.getState().user;
    const highlights = CallCardStore.getState()
      .comments.get(props.fileUpload.id, Map())
      .get(sessionUser.id, List())
      .filter(comment => comment.isRange());
    return FileUploadSharingDialogFormStore.getState()
      .merge(
        Map({
          shareDataError: FileUploadSharingStore.getState().get('shareDataError'),
          department: DepartmentStore.getState().get('department'),
          highlights,
        })
      )
      .toObject();
  }

  render() {
    return <FileUploadSharingDialogForm {...this.props} />;
  }
}

export default connectToStores(FileUploadSharingDialogFormContainer);
